<template>
  <div class="container">
      <div class="list">
          <div class="list_item" v-for="(item,index) in teams" :key="index">
              <img class="list_item-img" :src="item.imageUrl?item.imageUrl:require(`../../assets/images/img_default_face_${common.theme}.jpg`)"/>
              <span class="list_item-span1">{{item.name}}</span>
              <span class="list_item-span2">{{item.title}}</span>
          </div>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getParkMember } from "../../utils/api";
export default {
  name: "parkMemberList",

  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  filters: {
    },
  data() {
    return {
        parkId:'',
        teams:[],
    }
  },
   created() {
  },

   activated () {
    if (this.parkId !== this.$route.params.id) {
      this.parkId = this.$route.params.id;
      this.getParkMemberAction();
    }
  },

   methods: {
    getParkMemberAction() {
        let params = {
          "marketId": "4"|| this.common.marketInfo.id,
          "pageNo": "1",
          "pageSize": "100",
          "parkId": this.parkId
        }
        getParkMember(params).then(res => { {
            var ret =res.res;
            console.log(ret);
                if (res.res.code == 10000) {
                    console.log(res)
                    this.teams = res.body.parkMembers
                }
            }
            });
        }
    }
 };
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
}
.list{
    margin-left: 30px;
    width: 690px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.list_item{
    margin-top: 20px;
    width:172px ;
    height: 252px;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    justify-content: center;
}

.list_item-img{
    // margin-top: 40px;
    display: flex;
    width:100px;
    height:100px;
    border-radius:50px;
    background:rgba(232,236,255,1);

  }

  .list_item-span1{
    margin-top: 20px;
    display: flex;
    height:44px;
    font-size:32px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:44px;

  }

  .list_item-span2{
    margin-top: 8px;
    display: flex;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;

  }

</style>